package com.appcreator.compose.events

data class LoginEvent(
    val userId: String?,
    val email: String?,
    val displayName: String?
)